<script>
    export let tokenId;
    let tokenIndex = tokenId - 1;

    import {_owners as buttonOwners,
        _my_tokens as myButtons,
        purchase,
        _pending as pending,
        _requested as requested

    } from "../stores/contractButtons";

    let isPending, isRequested;

    let owned;
    let isMine;


    $:{
        isPending =   $pending.purchase[tokenId];
        isRequested = $requested.purchase[tokenId];

        owned = Boolean($buttonOwners[tokenIndex]);
        isMine = Boolean($myButtons[tokenId]);
    }


    function clickPurchase(){
        purchase(tokenId);
    }

</script>

<style>
    .button{
        display: flex;
        flex-direction: column;
    }
    .inner{
        display: flex;
        flex-direction: row;
    }
</style>

<div class="button">
    <h2>Button {tokenId}</h2>
    <div class="inner">
        <span>
            <video width="300" height="300" autoplay loop>
                <source src="https://amazing-geriatric-round-wolf.fission.app/token/{tokenIndex}/button{tokenIndex}.mp4" type="video/mp4">
            </video>
        </span>
        <span>
            <div>Is Owned: {owned}</div>
            {#if !owned}
                    <div>Purchase for 0.01 ETHs</div>
                {#if isPending}
                    <div>Pending...</div>
                {:else if isRequested}
                    <div>Requested...</div>
                {:else}
                    <button on:click={clickPurchase}>
                        PURCHASE
                    </button>
                {/if}
            {:else if isMine}
                You own it!
            {/if}
        </span>
    </div>




</div>